<template>
	<header :class="{ active: headerFixed }">
		<div class="nav">
			<div class="nav_left">
				<img v-if="!headerFixed" src="./img/logo.png" alt="logo" />
				<img v-else src="./img/logo1.png" alt="logo" />
			</div>
			<div class="nav_right">
				<ul>
					<router-link tag="li" to="/">{{ langtrans().sy[languageIndex] }}</router-link>
					<!-- <router-link tag="li" to="/dowapp">{{ langtrans().ddjx[languageIndex] }}APP</router-link> -->
					<router-link tag="li" to="/contact">{{ langtrans().hgzzzz[languageIndex] }}</router-link>
					<!-- <li class="li_a">
            <a :href="htmlLink">{{ langtrans().fxfbh[languageIndex] }}</a>
          </li> -->
					<li style="position: relative;" @mouseover="loginLeveShow = true" @mouseleave="loginLeveShow = false">
						<p class="btn_l">{{ langtrans().dl[languageIndex] }}</p>
						<ul class="login" v-show="loginLeveShow">
							<span></span>
							<li class="login_btn btn" @click="login(0)">{{ langtrans().jyjgrk[languageIndex] }}</li>
							<li class="login_btn btn" @click="login(2)">{{ langtrans().jjgjgr[languageIndex] }}</li>
							<li class="login_btn btn" @click="login(1)">{{ langtrans().zzzhzz[languageIndex] }}</li>
							<li class="login_btn btn" @click="login(3)">海外代表</li>
							<li class="login_btn btn" @click="login(4)">分公司调处登录</li>
							<li class="login_btn btn" @click="login(5)">总公司调处登录</li>
						</ul>
					</li>
					<li @mouseover="languageBoxShow = true" @mouseleave="languageBoxShow = false">
						<p>{{ languageName }}</p>
						<div class="langBox" v-show="languageBoxShow">
							<p @click="languageFun(0)">中文</p>
							<p @click="languageFun(1)">English</p>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<div class="mengban" v-show="mbShow">
			<div class="login_box" :class="{ guodu: mbShow }">
				<h2>{{ langtrans().ddjxjy[languageIndex] }}</h2>
        <div class="login_area" v-if="modify">
					<h2>修改密码</h2>
					<form class="login_div">
						<p><input type="text" :placeholder="langtrans().qsr[languageIndex]" v-model="modifyUser" /></p>
						<p><input type="password" placeholder="请输入原密码" v-model="modifyPwd" /></p>
						<p><input type="password" placeholder="请输入新密码" v-model="modifyNewPwd1" /></p>
            <p><input type="password" placeholder="请再次输入新密码" v-model="modifyNewPwd2" /></p>
						<span class="btn_cancel div_btn" @click="modify=false">{{ langtrans().qx[languageIndex] }}</span>
						<span class="btn_login div_btn" @click="submitForm">确定</span>
					</form>
				</div>
				<div class="login_area" v-else>
					<h2>{{ langtrans().dl[languageIndex] }}</h2>
					<form class="login_div">
						<p><input type="text" id="id_box" :placeholder="langtrans().qsr[languageIndex]" v-model="user" /></p>
						<p><input type="password" id="pwd_box" :placeholder="langtrans().qsrmm[languageIndex]" v-model="pwd" @keyup="enterFun($event)" /></p>
						<p class="pic_code"><input type="text" id="pic_code" :placeholder="langtrans().qsrcode[languageIndex]" v-model="code" /><img :src="imgCode" @click="getImgCode()"></p>
						<span class="btn_cancel div_btn" @click="cancel">{{ langtrans().qx[languageIndex] }}</span>
						<span class="btn_login div_btn" @click="submitFun">{{ langtrans().dl[languageIndex] }}</span>
            <!-- <em class="btn_cancel div_btn" @click="modify=true">修改密码</em> -->
					</form>
				</div>
			</div>
		</div>
	</header>
</template>

<script>
import axios from 'axios'
import langtrans from './indexHeader.vue.trans.js';
import { loginApi } from '@/views/axios/api.js';
import JsEncrypt from 'jsencrypt';
import { v4 as uuidv4} from 'uuid';

export default {
	data() {
		return {
			mbShow: false, //登录弹窗
			loginLeveShow: false,
			user: '',
			pwd: '',
			code: '',
			usertype: 0, //登录的类型
			headerFixed: false,
			languageBoxShow: false,
			languageName: '中文',
      htmlLink:'http://www.dajiuxing.com.cn/salesSystem',
      imgCode: '',
      publicKey: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCYkZgWwtAMghBA9Rz6WzFVkrr2q8cgdmodecIrMBYrNPuvH3Gi/hAwxYwbm1tM+97SSh75/xn5kOozGEXI6LUI5ETVuJ8cd3xaPgUABp1m2iCWIXrj8F2nQiniRthoyu4Ibkrhm8y/X2D8kSw4odmvGuC1w2lh7AyDcNrvSfL7KQIDAQAB',
      local_session: '',
      modify: false,
      modifyUser:'',
      modifyPwd: '',
      modifyNewPwd1: '',
      modifyNewPwd2: ''
		};
	},

	computed: {
		languageIndex() {
			return this.$store.state.language;
		}
	},
	mounted() {
    if(SEVSRS == 'http://api.dajiuxing.com.cn/'){
      this.htmlLink="http://www.dajiuxing.com.cn/salesSystem"
    }else{
      this.htmlLink="http://www.test.dajiuxing.com.cn/salesSystem"
    }
		if (this.$route.fullPath != '/') {
			this.headerFixed = true;
		} else {
			this.$nextTick(() => {
				window.onscroll = () => {
					var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
					if (scrollTop > 80) {
						this.gundong(true);
					} else {
						this.gundong(false);
					}
				};
			});
		}
		//设置语言
		if (JSON.parse(window.localStorage.getItem('language')) != undefined) {
			this.$store.commit('languageFun', JSON.parse(window.localStorage.getItem('language')));
			if (JSON.parse(window.localStorage.getItem('language')) == 0) {
				this.languageName = '中文';
			} else {
				this.languageName = 'English';
			}
		} else {
			window.localStorage.setItem('language', JSON.stringify('0'));
			this.$store.commit('languageFun', 0);
    }
    this.getImgCode()
	},
	methods: {
		languageFun(index) {
			if (index == 0) {
				this.languageName = '中文';
			} else {
				this.languageName = 'English';
			}
			this.languageBoxShow = false;
			window.localStorage.setItem('language', index);
			this.$store.commit('languageFun', index);
		},
		langtrans() {
			return langtrans;
		},
		gundong(status) {
			this.headerFixed = status;
		},
		login(str) {
			this.usertype = str;
			this.mbShow = true;
		},
		cancel() {
			this.mbShow = false;
		},
		enterFun(e) {
			if (e.keyCode == '13') {
				this.submitFun();
			}
		},
  	getImgCode(){
      if (!sessionStorage.getItem('local_session')) {
        this.local_session = uuidv4();
        sessionStorage.setItem('local_session', this.local_session)
      } else {
        this.local_session = sessionStorage.getItem('local_session');
      }
      axios.get(SEVSRS + 'rescue/user/generateValidateCode?local_session=' + this.local_session)
        .then(res => {
          this.imgCode = res.data
        })
        .catch(err => {
          console.log(err)
        })
    },
    /* 密码要求有 数字、字母 特殊字符 3种 的组合,
    * 密码最小长度最少要求有8位
    * 新密码中不能够包含帐户。
    */
    passwordValid(userName, pass) {
      let passLower = pass.toLocaleLowerCase();
      let flag = " ";
      if (
        pass === null ||
        pass.length < 8 ||
        pass.length === ""
      ) {
        flag = "密码位数不对，长度最少8位";
        return flag;
      }
      // 是数字
      let isDigit = /^.*[0-9]+.*/;
      // isLowerCase 字母
      let isLowerCase = /^.*[a-zA-Z]+.*/;
      // 特殊字符
      let regEx = /^.*[^a-zA-Z0-9]+.*/;
      // 记录匹配的次数
      let num = 0;
      if (isDigit.test(pass)) {
        num = num + 1;
      }
      if (isLowerCase.test(pass)) {
        num = num + 1;
      }
      if (regEx.test(pass)) {
        num = num + 1;
      }
      if (num <= 2) {
        flag ="密码复杂度不足,\n需包含字母、数字和特殊字符这三种字符";
        return flag;
      }
      //新密码中不能够包含帐户。
      if (pass.indexOf(userName) >= 0) {
        flag = "密码不能包含用户名";
        return flag;
      }
      return "correct";
    },
    /*密码加密规则*/
    RSAencrypt(pas) {
      let jse = new JsEncrypt();
      jse.setPublicKey(this.publicKey);
      return jse.encrypt(pas);
    },
		submitFun() {
      if (this.passwordValid(this.user,this.pwd) != "correct") {
        this.$message({
          message: this.passwordValid(this.user,this.pwd),
          type: "error"
        });
      }
			var data = {
				username: this.user,
				pwd: this.RSAencrypt(this.pwd),
        imageValidCode: this.code,
        local_session: this.local_session
      };
			loginApi(data)
				.then(res => {
					var data = res.data;
					if (data.code === 0) {
						if (Number(data.obj.user.type) == Number(this.usertype)) {
							if (this.usertype == 0 || this.usertype == 3) {
								this.$message({
									showClose: true,
									message: '救援机构登录成功',
									type: 'success'
								});
								window.localStorage.setItem(
									'data',
									JSON.stringify({
										data: data.obj.token
									})
								);

								window.localStorage.setItem(
									'usertype',
									JSON.stringify({
										data: data.obj.user.type
									})
								);

								window.localStorage.setItem('insti', JSON.stringify(data.obj.user.insti));
								window.localStorage.setItem('sendId', JSON.stringify(data.obj.user.id));
								this.$router.push({
									name: 'mainPase',
									params: {
										token: data.obj.token,
										insti: data.obj.user.insti
									}
								});
							} else if (this.usertype === 4) {
								this.$message({
									showClose: true,
									message: '分公司调处登录成功',
									type: 'success'
								});
								window.localStorage.setItem(
									'data',
									JSON.stringify({
										data: data.obj.token
									})
								);
								window.localStorage.setItem(
									'usertype',
									JSON.stringify({
										data: data.obj.user.type
									})
								);
								window.localStorage.setItem('insti', JSON.stringify(data.obj.user));
								window.localStorage.setItem('sendId', JSON.stringify(data.obj.user.id));
								this.$router.push({
									name: 'mainPaseRranch',
									params: {
										token: data.obj.token,
										insti: data.obj.user
									}
								});
							} else if (this.usertype === 2) {
								this.$message({
									showClose: true,
									message: '监管机构登录成功',
									type: 'success'
								});
								window.localStorage.setItem(
									'data',
									JSON.stringify({
										data: data.obj.token
									})
								);
								window.localStorage.setItem(
									'usertype',
									JSON.stringify({
										data: data.obj.user.type
									})
								);
								window.localStorage.setItem(
									'accountLevel',
									JSON.stringify({
										data: data.obj.user.accountLevel
									})
								);
								data.obj.user.insti.nameEn = data.obj.user.insti.name;
								window.localStorage.setItem('insti', JSON.stringify(data.obj.user.insti));
								window.localStorage.setItem('sendId', JSON.stringify(data.obj.user.id));
								this.$router.push({
									name: 'mainPaseRegulator',
									params: {
										token: data.obj.token,
										insti: data.obj.user.insti
									}
								});
							} else if (this.usertype === 1) {
								this.$message({
									showClose: true,
									message: '指挥中心登录成功',
									type: 'success'
								});
								window.localStorage.setItem(
									'data',
									JSON.stringify({
										data: data.obj.token
									})
								);
								window.localStorage.setItem(
									'usertype',
									JSON.stringify({
										data: data.obj.user.type
									})
								);
								data.obj.user.nameEn = '操作指挥中心';
								window.localStorage.setItem('insti', JSON.stringify(data.obj.user));
								window.localStorage.setItem('sendId', JSON.stringify(data.obj.user.id));
								this.$router.push({
									name: 'mainPaseCmdcenter',
									params: {
										token: data.obj.token,
										insti: data.obj.user
									}
								});
							}else if(this.usertype === 5){
								this.$message({
									showClose: true,
									message: '总公司调处登录成功',
									type: 'success'
								});
								window.localStorage.setItem(
									'data',
									JSON.stringify({
										data: data.obj.token
									})
								);
								window.localStorage.setItem(
									'usertype',
									JSON.stringify({
										data: data.obj.user.type
									})
								);
								window.localStorage.setItem('insti', JSON.stringify(data.obj.user));
								window.localStorage.setItem('sendId', JSON.stringify(data.obj.user.id));
								this.$router.push({
									name: 'mainPaseRranch'
								});
							}
						} else {
              this.getImgCode();
							if (this.usertype == 0 && data.obj.user.type != 0) {
								this.$message.error('登录失败，该用户不属于救援机构');
							} else if (this.usertype == 1 && data.obj.user.type != 1) {
								this.$message.error('登录失败，该用户不属于指挥中心');
							} else if (this.usertype == 2 && data.obj.user.type != 2) {
								this.$message.error('登录失败，该用户不属于监管机构');
							} else if (this.usertype == 4 && data.obj.user.type != 4) {
								this.$message.error('登录失败，该用户不属于分公司调处');
							} else if (this.usertype == 5 && data.obj.user.type != 5) {
								this.$message.error('登录失败，该用户不属于总公司调处');
							}
						}
					} else if (data.code === 200026) {
            this.getImgCode();
						//   alert("登录失败,用户名或密码错误");
						this.$message.error('登录失败，用户名或密码错误');
					} else {
            if (data.code != 109001) {
              this.getImgCode();
            }
						// this.$message.error('登录失败，未知错误');
						//   alert("登录失败,其他错误");
					}
					console.log(data);
				})
				.catch(err => {
          this.getImgCode();
					console.log(err);
				});
    },
    submitForm() {
      if (this.modifyNewPwd1 != this.modifyNewPwd2) {
        this.$message({
          message: "两次密码输入不一致",
          type: "error"
        });
        return false;
      } else if (this.modifyNewPwd1 == this.modifyPwd) {
        this.$message({
          message: "新密码不能与原密码相同",
          type: "error"
        });
        return false;
      } else if (this.passwordValid(this.modifyUser,this.modifyNewPwd1) != "correct") {
        this.$message({
          message: this.passwordValid(this.modifyUser,this.modifyNewPwd1),
          type: "error"
        });
        return false;
      }
      var data = {
        passport: this.modifyUser,
        password:this.RSAencrypt(this.modifyPwd),
        newPassword1:this.RSAencrypt(this.modifyNewPwd1),
        newPassword2:this.RSAencrypt(this.modifyNewPwd2)
      }
    }
	}
};
</script>
<style scoped="scoped">
a {
	color: white;
	text-decoration: none;
}
header {
	position: absolute;
	width: 100%;
	top: 0;
	background-color: rgba(0, 0, 0, 0.2);
	color: white;
}
.nav {
	font-size: 16px;
	padding: 15px 0;
	width: 1200px;
	margin: 0 auto;
	height: 50px;
}

.nav .nav_left {
	float: left;
}

.nav .nav_left img {
	height: 50px;
	display: block;
}

.nav .nav_right {
	width: 880px;
	float: right;
}

.nav_right > ul > li {
	float: left;
	margin-left: 30px;
	line-height: 50px;
	height: 50px;
	cursor: pointer;
	padding: 0 10px;
	text-align: center;
}
.nav_right > ul > li:hover {
	color: #00abf9;
}
.nav_right > ul > li:last-child {
	position: relative;
	margin-left: 10px;
}
.nav_right > ul > li:last-child:hover {
	color: #fff;
}
.active .nav_right > ul > li:last-child:hover {
	color: #666;
}
.active .nav_right > ul > li:last-child > .langBox {
	color: #fff;
}
.nav_right > ul > li:nth-child(4) {
	position: relative;
}
.nav_right > ul > li:last-child > p {
	text-align: center;
	width: 80px;
}
.nav_right .langBox {
	width: 80px;
	position: absolute;
	top: 50px;
	left: 0px;
	border: 1px solid #163da0;
	background: #0e183c;
	z-index: 10;
}
.nav_right .langBox p {
	text-align: center;
	margin-left: 0;
	border-bottom: 1px solid #163da0;
	margin: 0 10px;
}
.nav_right .langBox p:last-child {
	border: none;
}
.nav_right .langBox p:hover {
	color: #00abf9;
}
.nav_right .router-link-exact-active {
	color: #00abf9;
	border-bottom: 2px solid #00abf9;
}
.login {
	position: absolute;
	width: 150px;
	top: 50px;
	right: -15px;
	border: 1px solid #163da0;
	background: #0e183c;
	border-radius: 3px;
	color: #000;
	overflow: hidden;
	padding: 0 15px;
	z-index: 2;
}

.login li {
	text-align: center;
	line-height: 50px;
	font-size: 16px;
	color: #fff;
	border-bottom: 0.0625vw solid #163da0;
	margin: 0;
	padding: 0;
	width: 100%;
	white-space: nowrap;
}

.login li:last-child {
	border-bottom: 0;
}

.login li:hover {
	color: #00abf9;
}
.btn_l {
	border: 1px solid #00abfa;
	width: 80px;
	height: 28px;
	border-radius: 5px;
	line-height: 28px;
	text-align: center;
	color: #00abfa;
	margin-top: 10px;
}
/*登录弹窗*/
.mengban {
	position: fixed;
	top: 0;
	left: 0;
	z-index: 2;
	width: 100%;
	background-color: rgba(0, 0, 0, 0.3);
	min-height: 100vh;
}
.login_box {
	background: url(./../../../static/images/login_back.jpg) no-repeat;
	background-size: 100% 100%;
	height: 30.7vw;
	width: 64vw;
	border: 0.0625vw solid #163da0;
	border-radius: 0.3125vw;
	z-index: 2;
	margin: 0 auto;
	margin-top: 12%;
	position: relative;
}

.login_area {
	position: absolute;
	background: url(./../../../static/images/login_login.png) no-repeat;
	background-size: 100% 100%;
	width: 17.18vw;
	height: 15vw;
	right: 7.3vw;
	top: 10.4vw;
}

.login_box h2 {
	text-align: center;
	width: 100%;
	line-height: 2.6vw;
	color: #00abf9;
}

.login_box > h2 {
	position: absolute;
	width: 17.18vw;
	right: 7.3vw;
	top: 7.3vw;
	font-size: 1.14vw;
}

.login_area > h2 {
	font-size: 0.8vw;
	line-height: 2.9vw;
	color: #3b86c0;
}

.login_box .login_div {
	text-align: center;
	color: #000;
	width: 100%;
}

.login_div p {
	font-size: 0.93vw;
	width: 100%;
	text-align: center;
	height: 1.35vw;
	margin-bottom: 0.93vw;
	padding: 0 2.35vw;
	-webkit-box-sizing: border-box;
    box-sizing: border-box;
}

.login_div p input {
	display: block;
	height: 1.25vw;
	width: 11.8vw;
	font-size: 0.8vw;
	border: 0.0625vw solid #3e5694;
	padding-left: 0.625vw;
	line-height: 1.25vw;
	background: #152651;
	color: #fff;
}
.login_div .pic_code input {
	width: 7.5vw;
	float: left;
	/* margin-left: 2.69vw; */
}
.login_div .pic_code img{
	width: 3.8vw;
	height: 1.375vw;
	float: right;
}

.login_div p input::-webkit-input-placeholder {
	color: #3b86c0;
}

.login_div p input::-moz-placeholder {
	color: #3b86c0;
}

.login_div p input:-ms-input-placeholder {
	color: #3b86c0;
}

.login_div span {
	margin: 0.5vw 1.04vw 0 1.04vw;
	display: inline-block;
	background: #0e183c;
	border: 0.0625vw solid #00abf9;
	color: #00abf9;
	width: 5.56vw;
	height: 1.45vw;
	font-size: 0.8vw;
	line-height: 1.56vw;
	cursor: pointer;
}
.login_div em{
  color: #00abf9;
  cursor: pointer;
  font-size: 0.8vw;
	line-height: 1.56vw;
  font-style: normal;
  display: block;
  text-align: right;
  padding-right: 1.6vw;
  margin-top: 0.7vw;
}

.login_div span.btn_login.div_btn {
	background: #00abf9;
	color: #fff;
}
.active {
	width: 100%;
	position: fixed;
	top: 0;
	left: 0;
	background-color: white;
	color: #666;
	z-index: 100;
	border-bottom: 1px solid #ccc;
}
.active a {
	color: #666;
}
.guodu {
	animation-duration: 0.75s;
	animation-name: zoomInDown;
	animation-fill-mode: forwards;
}
@-webkit-keyframes zoomInDown {
	from {
		opacity: 0;
		-webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
		transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
		-webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
		animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
	}

	60% {
		opacity: 1;
		-webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
		transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
		-webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
		animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
	}
}

@keyframes zoomInDown {
	from {
		opacity: 0;
		-webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
		transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
		-webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
		animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
	}

	60% {
		opacity: 1;
		-webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
		transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
		-webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
		animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
	}
}
</style>



// WEBPACK FOOTER //
// src/components/header/indexHeader.vue